import { defineMessages } from 'react-intl';

const messages = defineMessages({
  selectDate: {
    description: 'Date Range Component empty selection label',
    defaultMessage: 'Select a date range',
    id: 'tcrMuO',
  },
  remove: {
    description: 'Date Range Component - Remove',
    defaultMessage: 'Remove',
    id: 'UtOJOk',
  },
  apply: {
    description: 'Date Range Component - Apply',
    defaultMessage: 'Apply',
    id: '5XOC26',
  },
  dateToday: {
    description: 'Date Range Component dateToday',
    defaultMessage: 'Today',
    id: 'sqmY6G',
  },
  dateYesterday: {
    description: 'Date Range Component dateYesterday',
    defaultMessage: 'Yesterday',
    id: '0+tdiE',
  },
  dateLastWeek: {
    description: 'Date Range Component dateLastWeek',
    defaultMessage: 'In the Last 7 Days',
    id: 's1InE/',
  },
  dateLast30Days: {
    description: 'Date Range Component dateLast30Days',
    defaultMessage: 'In the Last 30 days',
    id: 'DDY6C9',
  },
  dateThisMonth: {
    description: 'Date Range Component dateThisMonth',
    defaultMessage: 'This Month',
    id: 'veAV9M',
  },
  dateLastMonth: {
    description: 'Date Range Component dateLastMonth',
    defaultMessage: 'Last Month',
    id: 'If0ZDB',
  },
  dateCustomRange: {
    description: 'Date Range Component dateCustomRange',
    defaultMessage: 'Custom Range',
    id: 'CI7d/u',
  },
});

export default messages;
